var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":("Bloqueo periodo " + _vm.code),"value":true},on:{"close-modal":_vm.closeModal}},[_c('accounting-period-lock-form',{attrs:{"id":_vm.id},on:{"on-close":_vm.closeModal}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84f6635c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounting-periods/page-accounting-period-lock.vue
// module id = 1381
// module chunks = 38